"use client";

import { Box, Grid } from "@mui/joy";
import { LaborCard } from "./LaborCard";
import { LaborSelection } from "../../../interfaces";

interface LaborProps {
    laborItems: any[];
    selectedValues: Record<string, LaborSelection>;
    onQuantityChange: (serviceId: string, event: "add" | "remove") => void;
    onRemove?: (serviceId: string) => void;
    priceRanges?: Record<string, { min: number; max: number }>;
}

export function Labor({ laborItems, selectedValues, onQuantityChange, onRemove, priceRanges }: LaborProps) {
    return (
        <Box>
            <Box>
                <Grid container spacing={1}>
                    {laborItems.map((laborItem) => (
                        <Grid xs={12} key={laborItem.Id} mb={1}>
                            <LaborCard
                                laborItem={laborItem}
                                selectedValue={selectedValues[laborItem.Id]}
                                onQuantityChange={onQuantityChange}
                                onRemove={onRemove}
                                priceRange={priceRanges?.[laborItem.Id]}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>
    );
}
